module.exports = __webpack_public_path__ + "static/media/ic_fb_black.350819d6.svg";